export type TrialRequestContact = {
  name: string;
  email: string;
  phone: string;
  emailSubject: string;
  emailBody: string;
  smsBody: string;
  tel: string;
  wa: string;
};

export function buildTrialRequestContact(input: {
  vorname?: string | null;
  nachname?: string | null;
  email?: string | null;
  telefon?: string | null;
}): TrialRequestContact {
  const name = `${(input.vorname || '').trim()} ${(input.nachname || '').trim()}`.trim();
  const email = (input.email || '').trim();
  const phone = (input.telefon || '').trim();
  const emailSubject = 'Probestunden-Anfrage – Rückmeldung';
  const emailBody = `Hallo ${name || '...'},\n\nvielen Dank für Ihre Anfrage für eine Probestunde. Gerne stimmen wir einen Termin mit Ihnen ab.\n\nMit freundlichen Grüßen`;
  const smsBody = `Hallo ${name || '...'}, vielen Dank für Ihre Anfrage für eine Probestunde. Wir melden uns zur Terminabstimmung.`;

  const tel = phone ? `tel:${phone}` : '';
  const wa = phone ? `https://wa.me/${phone.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(smsBody)}` : '';

  return { name, email, phone, emailSubject, emailBody, smsBody, tel, wa };
}


